import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class RouterPathService {


  pathSeperator: string = '/';
  loginString: string = 'login';
  projectsString: string = 'projects';

  manageProjectString: string = 'manageProject';
  roofPlanString: string = 'roofPlan';
  inverterPlanString: string = 'inverterPlan';
  createProjectString: string = 'createProject';
  settingsString: string = 'settings';

  MPProjectString: string = 'project';
  MPCalculationProfitabilityString: string = 'calculationProfitability';
  MPItemListString: string = 'itemList';
  MPPrintSystemDocumentsString: string = 'printSystemDocuments';
  MPPrintOfferString: string = 'printOffer';
  MPInstallationTimeString: string = 'installationTime';

  RPMountingString: string = 'mounting'
  RPShapeString: string = 'shape';
  RPStructureString: string = 'structure';
  RPPanelString: string = 'panel';
  RPItemListString: string = 'itemList';


  IPSearchInverterString: string = 'searchInverter';
  IPCustomizeString: string = 'customize';
  IPStringingString: string = 'stringing';
  IPAcdcString: string = 'acdc';

  settingsPath: string = `${this.pathSeperator}${this.projectsString}${this.pathSeperator}${this.settingsString}`;
  manageProjectPath: string = `${this.pathSeperator}${this.projectsString}${this.pathSeperator}${this.manageProjectString}`;
  createProjcetPath: string = `${this.pathSeperator}${this.projectsString}${this.pathSeperator}${this.createProjectString}`;
  roofPlanPath: string = `${this.pathSeperator}${this.projectsString}${this.pathSeperator}${this.roofPlanString}`;
  inverterPlanPath: string = `${this.pathSeperator}${this.projectsString}${this.pathSeperator}${this.inverterPlanString}`;

  MPProjectPath: string = `${this.manageProjectPath}${this.pathSeperator}${this.MPProjectString}`;
  MPItemListPath: string = `${this.manageProjectPath}${this.pathSeperator}${this.MPItemListString}`;
  RPMountingPath: string = `${this.roofPlanPath}${this.pathSeperator}${this.RPMountingString}`;
  IPSearchInverterPath: string = `${this.inverterPlanPath}${this.pathSeperator}${this.IPSearchInverterString}`;
}
